<template>
    <div class="logo">
        <h1 class="text-center mb-5">{{ mensagem }}</h1>

        <DialogCommercialHierarchyLogin v-model="dialogCommercialHierarchyVisible" :items="commercialHierarchyData" :show-close-button="false" />
        <DialogCommercialHierarchyAssistentLogin v-model="dialogAssistentCommercialHierarchyVisible" :items="commercialHierarchyAssistentData" @validateHierarchyReturn="validateHierarchyReturn" />
    </div>
</template>

<script>

  import { flavorRes, loadFlavor } from '../plugins/flavors'
  import { autenticarNewConEscritorio2 } from '../webservice/autenticar'
  import { alert, findUnidadeMultiplasEmpresas, notification } from '../plugins/helpers'
  import { origensAcesso } from '@/plugins/constants'
  import DialogCommercialHierarchyLogin from '@/components/hierarquia-comercial/DialogCommercialHierarchyLogin.vue'
  import commercialHierarchy from '@/mixins/commercialHierarchy'
  import DialogCommercialHierarchyAssistentLogin from '@/components/hierarquia-comercial/DialogCommercialHierarchyAssistentLogin.vue'
  import { AlertTypes } from '../plugins/alerts_types'

  export default {
    name: 'LoginExternoEscritoriov2',
    components: { DialogCommercialHierarchyAssistentLogin, DialogCommercialHierarchyLogin },
    mixins: [commercialHierarchy],
    data: () => ({
      mensagem: 'Autenticando...',
      logo: ''
    }),
    mounted () {
      this.$session.destroy()
      loadFlavor('rodobens')
      this.logo = flavorRes('img/logo-menu.png')

      const params = this.$route.query

      autenticarNewConEscritorio2(params.token)
        .then(async (res) => {
          let ambientesPorUsuario = await this.$http.post('/ambientes-por-usuario', {
            data: res.data,
            empresas: res.data.Empresas
          }).then(res => {
            return res.data
          })
          return { res, ambientesPorUsuario }
        })
        .catch(err => {
          this.$session.destroy()
          notification(AlertTypes.ERROR, err, 'Não foi possível realizar o login!', true)
        })
        .then(({ res, ambientesPorUsuario }) => {
          if (this.validateHierarchyReturn(res)) {
            return
          }
          this.$session.set('origem_acesso', origensAcesso.sso)
          const empresas = res.data.Empresas.Empresa
          const unidades = res.data.UnidadesNegocio
          const id_empresa = this.$session.get('id_empresa')
          const id_unidade = this.$session.get('id_unidade_negocio')

          const ids_empresas_permitidas_usuario = empresas.map(empresa => empresa.ID_Empresa)
          const ids_empresas_permitidas_ambiente = ambientesPorUsuario.empresas_permitidas.map(empresa => empresa.ID_Empresa)

          let id_representante = null

          if (empresas) {
            this.$session.set('id_empresa', id_empresa)
            this.$session.set('empresas', empresas)

            const filial = res.data['FiliaisVenda']['FilialVenda'].find(filial => filial.ID_Empresa === id_empresa)

            if (filial) {
              this.$session.set('filial', filial)
            }
          } else {
            alert(`A empresa ${id_empresa} é inválida. Consulte a administradora`)
            return
          }

          if (id_representante && id_representante.length > 30) {
            notification('warning', 'Identificador do representante inválido.')
            return
          }
          const unidade = findUnidadeMultiplasEmpresas(id_unidade, unidades, ids_empresas_permitidas_usuario, this.$session.get('vendas_backoffice'))
          if (unidade) {
            this.$session.set('id_unidade_negocio', id_unidade)
            this.$session.set('unidades', [unidade])
          } else {
            alert(`A Unidade de Negócio ${id_unidade} é inválida. Consulte a administradora`)
            return
          }
          this.$session.set('identificador_representante_tribanco', id_representante)
          this.$session.set('ids_empresas_permitidas', ids_empresas_permitidas_ambiente)

          this.$session.set('unidade_exclusiva', ambientesPorUsuario.unidade_negocio_exclusiva)
          if (res.data.vendas_backoffice) {
            this.$router.replace('/')
          } else {
            this.$router.replace('/escolher_ambiente')
          }
        })
    }

  }
</script>

<style scoped>
    .logo {
        width: 100%;
        margin-top: 15px;
    }

    .logo img {
        margin: auto;
        display: block;
    }
</style>
